import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastComponent, ToastData } from '@shared/components/toast/toast.component';

const DEFAULT_DURATION = 3000;

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly snackBar = inject(MatSnackBar);

  success(title: string, message = ''): void {
    this.show('success', title, message);
  }

  error(title: string, message = ''): void {
    this.show('error', title, message);
  }

  warning(title: string, message = ''): void {
    this.show('warning', title, message);
  }

  info(title: string, message = ''): void {
    this.show('info', title, message);
  }

  show(type: ToastData['type'], title: string, message = '', ms = DEFAULT_DURATION): void {
    const data: ToastData = { type, title, message: message || undefined, duration: ms };
    this.snackBar.openFromComponent(ToastComponent, {
      data,
      duration: ms,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: ['app-toast-panel']
    });
  }

  dismiss(): void {
    this.snackBar.dismiss();
  }
}
